import { render } from "./NavFooter.vue?vue&type=template&id=378d6a03&scoped=true"
import script from "./NavFooter.vue?vue&type=script&lang=js"
export * from "./NavFooter.vue?vue&type=script&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=378d6a03&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378d6a03"]])

export default __exports__